import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/auth/Login.vue";
import AutoLogin from "../views/auth/AutoLogin.vue";
import sms from "../views/auth/sms.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/preview-file/:token",
    name: "PublicAccess",
    props: true,
    component: () => import("../views/public/PublicAccess.vue"),
  },
  {
    path: "/sms/:token",
    name: "sms",
    component: sms,
    props: true,
    // beforeEnter: (to, from, next) => {
    //   if (localStorage.getItem("token")) {
    //     next("user-profile");
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/",
    name: "login",
    component: Login,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("token")) {
        next("user-profile");
      } else {
        next();
      }
    },
  },
  {
    path: "/autologin/:token",
    name: "AutoLogin",
    component: AutoLogin,
    props: true,
    beforeEnter: (to, from, next) => {
      if (localStorage.getItem("token")) {
        next("user-profile");
      } else {
        next();
      }
    },
  },

  {
    path: "/cdr-whatsapp/:id",
    name: "CDR Whatsapp newTab",
    meta: {
      checkRole: [1, 2, 4, 6, 7],
    },
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "admin" */
        "../components/CDR/Whatsapp/ExternalMessageDialog.vue"
      ),
  },

  {
    path: "/directory-list",
    name: "DirectoryList",
    component: () => import("../views/app/publicPages/DirectoryPublicView.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: () => import("../views/auth/SignUp.vue"),
  },
  {
    path: "/bugs-report",
    name: "BugsReport",
    component: () => import("../views/BugsReport.vue"),
  },
  {
    path: "/verify",
    name: "Verify",
    component: () => import("../views/auth/Verify.vue"),
  },
  {
    path: "/extension-queue-status",
    name: "Monitoreo",
    component: () =>
      import(
        /* webpackChunkName: "admin" */
        "../views/public/ExtensionQueueStatus.vue"
      ),
  },
  {
    path: "/admin",
    name: "AdminLayout",
    component: () => import("../views/layout/AdminLayout.vue"),
    meta: {
      requiresAuth: true,
    },
    redirect: {
      name: "Dashboard",
    },
    children: [
      {
        path: "/chats",
        name: "Chats",
        component: () => import("../views/app/chats/chatPanel.vue"),
        meta: {
          checkRole: [3],
        },
      },
      {
        path: "/user-messages",
        name: "Mensajes",
        meta: {
          checkRole: [1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/UserMessages"
          ),
      },
      {
        path: "/campaigns",
        name: "Campañas",
        meta: {
          checkRole: [1, 2, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Campaigns"
          ),
      },
      {
        path: "/surveys",
        name: "Encuestas",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Surveys"
          ),
      },
      {
        path: "/callbacks",
        name: "Devolucion de Llamadas",
        meta: {
          checkRole: [1, 2, 3, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Callbacks"
          ),
      },
      {
        path: "/campaigns/:id",
        name: "Campaña: ",
        props: true,
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CampaignDetails"
          ),
      },
      {
        path: "/tipificacion",
        name: "Tipificacion",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Typification"
          ),
      },
      {
        path: "/reporte-pruebas/:id",
        props: true,
        name: "Evaluacion",
        meta: {
          checkRole: [1, 2, 3, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/TestReports/EvaluationReport"
          ),
      },
      {
        path: "/reporte-pruebas",
        name: "Reporte de Pruebas",
        meta: {
          checkRole: [1, 2, 3, 4, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/TestReports.vue"
          ),
      },
      {
        path: "/tests",
        name: "Pruebas",
        meta: {
          checkRole: [1, 2, 3, 4, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Tests"
          ),
      },
      {
        path: "/evaluations",
        name: "Evaluaciones",
        meta: {
          checkRole: [1, 2, 3, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Evaluations"
          ),
      },
      {
        path: "/categories",
        name: "Categorias",
        meta: {
          checkRole: [1, 2, 3, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Categories"
          ),
      },
      {
        path: "/categories/:id/questions",
        props: true,
        name: "Preguntas",
        meta: {
          checkRole: [1, 2, 3, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Questions"
          ),
      },
      // HOME
      {
        path: "/home",
        name: "Home",
        meta: {
          checkRole: [1, 2, 4, 6, 7, 8, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Home.vue"
          ),
      },
      // HOME FOR CALLS
      {
        path: "/home-calls",
        name: "Home Calls",
        meta: {
          checkRole: [9],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/HomeForCalls.vue"
          ),
      },
      // AGENTS
      {
        path: "/welcome",
        name: "Bienvenido",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/HomeForAgents.vue"
          ),
      },
      // WHATSAPP
      {
        path: "/whatsapp",
        name: "WhatsApp",
        meta: {
          checkRole: [4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/HomeForWhatsApp.vue"
          ),
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/Dashboard.vue"
          ),
      },
      {
        path: "/dashboard-tipificacion",
        name: "Dashboard tipificaciones",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/DashboardTipificaciones.vue"
          ),
      },
      {
        path: "/dashboard",
        name: "Dashboard",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/Dashboard.vue"
          ),
      },
      {
        path: "/dashboard-whatsapp",
        name: "Dashboard WhatsApp",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/Dashboard2.vue"
          ),
      },
      {
        path: "/dashboard2",
        name: "Dashboard 2",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/Dashboard3.vue"
          ),
      },
      {
        path: "/queue-dashboard",
        name: "Dashboard colas",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/dashboards/DashboardQueues.vue"
          ),
      },
      {
        path: "/activity-overview/cdr",
        name: "Resumen de Actividad - CDR",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/ActivityOverview/CDR.vue"
          ),
      },
      {
        path: "/activity-overview/calls-information",
        name: "Resumen de Actividad - Informe de llamadas",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/ActivityOverview/CallsInformation.vue"
          ),
      },
      {
        path: "/activity-overview/queues",
        name: "Resumen de Actividad - Colas",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/ActivityOverview/Queues.vue"
          ),
      },
      {
        path: "/activity-overview/breaks",
        name: "Resumen de Actividad - Pausas",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/ActivityOverview/Breaks.vue"
          ),
      },
      {
        path: "/test-report/:user/:status/:id",
        props: true,
        name: "Detalle de Pruebas - Agentes",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/TestReports/EvaluationReport"
          ),
      },
      {
        path: "/test-report",
        name: "Reporte de Pruebas - Agentes",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/TestReport.vue"
          ),
      },
      {
        path: "/agent-tipificacion",
        name: "Tipificacion - Agentes",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/Typification"
          ),
      },
      {
        path: "/dial-module",
        name: "Marcacion - Agentes",
        meta: {
          checkRole: [3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/DialModule"
          ),
      },
      // MISC
      {
        path: "/accumulate-indicators",
        name: "Indicadores acumulados",
        meta: {
          checkRole: [1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/reports/accumulatedIndicators/accumulatedIndicators.vue"
          ),
      },
      {
        path: "/queue-report",
        name: "Informe de Cola",
        meta: {
          checkRole: [1, 2, 4, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/QueueReport.vue"
          ),
      },
      {
        path: "/chat-report",
        name: "Informe de Chats",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/reports/chats/ReportChat.vue"
          ),
      },
      {
        path: "/calls-information",
        name: "Información de llamadas",
        meta: {
          checkRole: [1, 2, 4, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CallsInfo.vue"
          ),
      },
      {
        path: "/cdr",
        name: "CDR",
        meta: {
          checkRole: [1, 2, 4, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CDR.vue"
          ),
      },
      {
        path: "/cdr-whatsapp",
        name: "CDR Whatsapp",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CDRWhatsApp.vue"
          ),
      },
      {
        path: "/clients-information",
        name: "Informacion de Clientes",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/ClientsInformation.vue"
          ),
      },

      // FORMULARIOS (FORM BUILDER)
      {
        path: "/new-Survey",
        name: "Crear Encuesta",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/settings/formBuilder/newForm.vue"
          ),
      },
      {
        path: "/new-form-link",
        name: "Crear enlaces",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/externalForm/newExternalForm.vue"
          ),
      },
      {
        path: "/form-builder",
        name: "Form builder",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/settings/formBuilder/FormBuilder.vue"
          ),
      },
      {
        path: "/forms",
        name: "Formularios",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/index.vue"
          ),
      },
      {
        path: "/external-forms",
        name: "Formularios externos",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/externalForm/externalForm.vue"
          ),
      },
      {
        path: "/form-details",
        name: "Detalles de formulario",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/showDetails.vue"
          ),
      },
      {
        path: "/take-survey",
        name: "Completar formulario",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/takeSurvey.vue"
          ),
      },
      {
        path: "/forms-results",
        name: "Resultados formularios",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/formBuilder/results/FormsResults.vue"
          ),
      },
      {
        path: "/cdr",
        name: "CDR",
        meta: {
          checkRole: [1, 2, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CDR.vue"
          ),
      },
      // {
      //     path: "/outgoing-calls",
      //     name: "Llamadas Salientes",
      //     meta: {
      //         checkRole: [1, 2]
      //     },
      //     component: () =>
      //         import(
      //             /* webpackChunkName: "admin" */
      //             "../views/app/OutgoingCalls.vue"
      //         )
      // },
      {
        path: "/users",
        name: "Usuarios",
        meta: {
          checkRole: [1, 2, 6, 7, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Users/Manage.vue"
          ),
      },
      {
        path: "/clients",
        name: "Clientes",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Clients/ShowClients.vue"
          ),
      },
      {
        path: "/external-clients",
        name: "Clientes externos",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/ExternalClients/ShowExternalClients.vue"
          ),
      },
      {
        path: "/survey-config",
        name: "Configurar encuestas",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/whatsAppSurvey/index.vue"
          ),
      },
      {
        path: "/presms-config",
        name: "Mensajes predefinidos",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/smsConfig/index.vue"
          ),
      },
      {
        path: "/bots-config",
        name: "Configurar Bots",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/bot/index.vue"
          ),
      },
      {
        path: "/whatsapp-config",
        name: "Configurar WhatsApp",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/whatsAppConfig/index.vue"
          ),
      },
      {
        path: "/webrtc-config",
        name: "Configurar WebRTC",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/webRtcConfig/index.vue"
          ),
      },
      {
        path: "/external-clients-campaign",
        name: "Cliente externo campañas",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/externalCampaignConfig/ExternalClientCampaign.vue"
          ),
      },

      {
        path: "/user-profile",
        name: "Perfil",
        meta: {
          checkRole: [0, 1, 2, 3, 6, 7, 8, 9, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/app/profile/ShowProfile.vue"
          ),
      },
      {
        path: "/campaign-settings",
        name: "Configurar Campañas",
        meta: {
          checkRole: [0, 1, 2, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/campaign/campaignConfig.vue"
          ),
      },
      {
        path: "/campaign-var-names",
        name: "Nombre de variables",
        meta: {
          checkRole: [0, 1, 2, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/campaign/varNames/varNamesCampaign.vue"
          ),
      },
      {
        path: "/break-settings",
        name: "Configurar Pausas",
        meta: {
          checkRole: [0, 1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Breaks/ShowBreaks.vue"
          ),
      },
      {
        path: "/active-calls",
        name: "Llamadas activas",
        meta: {
          checkRole: [0, 1, 2, 4, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/monitoring/ActiveCalls.vue"
          ),
      },
      {
        path: "/active-break",
        name: "Pausas activas",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/ActiveBreaks.vue"
          ),
      },
      {
        path: "/agents",
        name: "Agentes creados",
        meta: {
          checkRole: [0, 1, 2, 4, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/AgentList.vue"
          ),
      },
      {
        path: "/agents-history",
        name: "Historial agente",
        meta: {
          checkRole: [0, 1, 2, 4, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/AgentListHistory"
          ),
      },
      {
        path: "/breakAdmin",
        name: "Agentes bloqueados",
        meta: {
          checkRole: [0, 1, 2, 3, 4, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Breaks/AdminBreaks/ShowAdminBreaks"
          ),
      },
      {
        path: "/breakAdminUnlock",
        name: "Historial de bloqueados",
        meta: {
          checkRole: [0, 1, 2, 3, 4, 7, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Breaks/AdminBreaks/ShowAgentUnlock"
          ),
      },
      {
        path: "/assistanceList",
        name: "Asistencia del día",
        meta: {
          checkRole: [0, 1, 2, 3, 4, 7, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Assistance/AssistanceList"
          ),
      },
      {
        path: "/assistanceHistory",
        name: "Historial de asistencia",
        meta: {
          checkRole: [0, 1, 2, 4, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../components/Assistance/AssistanceHistory"
          ),
      },
      {
        path: "/productivityReport/:type",
        name: "Reporte de productividad",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/agents/ProductivityReport.vue"
          ),
      },
      {
        path: "/pricing-report",
        name: "Reporte Tarificador",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/reports/pricing/index.vue"
          ),
      },
      {
        path: "/pricing-report-cdr",
        name: "Reporte Tarificador Marcador",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/reports/cdrPricing/index.vue"
          ),
      },
      {
        path: "/ShowColas",
        name: "Colas",
        meta: {
          checkRole: [0, 1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../components/Typifications/ShowQueue"
          ),
      },
      {
        path: "/StatusColas",
        name: "Monitoreo de colas",
        meta: {
          checkRole: [0, 1, 2, 4, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../components/Typifications/Queue/StatusQueue.vue"
          ),
      },
      {
        path: "/ExtensionStatus",
        name: "Estado de las estaciones",
        meta: {
          checkRole: [0, 1, 2, 4, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../components/Typifications/Extensions/ExtensionStatus.vue"
          ),
      },
      {
        path: "/DetailStatusColas",
        name: "Detalle del estado de colas",
        meta: {
          checkRole: [0, 1, 2, 6, 7, 10],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../components/Typifications/Queue/DetailStatusQueue"
          ),
      },
      {
        path: "/Typifications",
        name: "ShowTypifications",
        meta: {
          checkRole: [0, 1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../components/Typifications/Typifications/ShowTypifications"
          ),
      },
      {
        path: "/contacts",
        name: "Contacts",
        meta: {
          checkRole: [0, 1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/Contacts.vue"
          ),
      },
      {
        path: "/directory",
        name: "Directorio",
        meta: {
          checkRole: [0, 1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/Directory"
          ),
      },
      {
        path: "/pricing-settings",
        name: "Tarificador",
        meta: {
          checkRole: [0, 1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/settings/pricing/index.vue"
          ),
      },
      {
        path: "/typification-report",
        name: "Reporte de Tipificaciones",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/TypificationReport"
          ),
      },
      {
        path: "/channels-report",
        name: "Reporte de Canales",
        meta: {
          checkRole: [1, 2, 4, 6, 7],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/ChannelsReport"
          ),
      },
      {
        path: "/gateway-settings",
        name: "Gateways",
        meta: {
          checkRole: [0, 1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/GatewaySettings.vue"
          ),
      },
      // Scheduled Task
      {
        path: "/scheduled-task",
        name: "Tareas programadas",
        meta: {
          checkRole: [0, 1, 2, 3, 6, 7, 8],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/scheduledTask/scheduledTaskIndex.vue"
          ),
      },
      {
        path: "/deep-survey",
        name: "Deep Surveys",
        meta: {
          checkRole: [0, 1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */

            "../views/app/DeepSurveys"
          ),
      },
      {
        path: "/trunks",
        name: "Troncales",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/clientSettings/trunks/index.vue"
          ),
      },
      {
        path: "/channels",
        name: "Canales",
        meta: {
          checkRole: [1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/reports/channels/index.vue"
          ),
      },
      {
        path: "/call-buttons",
        name: "Botones de Llamadas",
        meta: {
          checkRole: [1],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/CallButtons.vue"
          ),
      },
      {
        path: "/audit-records",
        name: "Registros por auditar",
        meta: {
          checkRole: [1, 2, 4],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/AuditRecords.vue"
          ),
      },
      {
        path: "/extensions",
        name: "Extensiones",
        meta: {
          checkRole: [1, 2, 6],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/settings/extensions/index.vue"
          ),
      },
      {
        path: "/appointments/templates",
        name: "Citas - Plantillas",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Appointments/Templates.vue"
          ),
      },
      {
        path: "/appointments/list",
        name: "Citas - Lista",
        meta: {
          checkRole: [1, 2, 3],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Appointments/Appointments.vue"
          ),
      },
      {
        path: "/appointments/specialties",
        name: "Citas - Especialidades",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Appointments/Specialties.vue"
          ),
      },
      {
        path: "/appointments/specialties-responsible",
        name: "Citas - Responsables",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Appointments/Responsible.vue"
          ),
      },
      {
        path: "/appointments/campaigns",
        name: "Citas - Campañas",
        meta: {
          checkRole: [1, 2],
        },
        component: () =>
          import(
            /* webpackChunkName: "admin" */
            "../views/app/Appointments/Campaigns.vue"
          ),
      },

	{
	  path: "/appointments/report",
	  name: "Reporte de Citas", // <--- ESTO DEBE SER IDÉNTICO AL 'path' DEL DRAWER
	  component: () => import("../views/app/Appointments/AppointmentReport.vue"),
	  meta: {
	    requiresAuth: true,
	    checkRole: [1, 2],
	  }
	},

//      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
  base: process.env.BASE_URL,
  routes,
});

// loading routes
router.afterEach(() => {
  setTimeout(() => {
    store.commit("setSplashScreen", false);
  }, 0);
});

// PROTECCION DE RUTAS
router.beforeEach((to, _from, next) => {
  // Consulta VUEX
  const authUser = store.getters["passport/AUTHENTICATED"];
  const UserRole = localStorage.getItem("user");
  // CREACION META
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!authUser) {
      next({
        path: "/",
      });
    } else {
      if (!to.meta.checkRole || to.meta.checkRole.includes(JSON.parse(UserRole).role_id)) {
        next();
      } else {
        router
          .push({
            name: "ShowProfile",
          })
          .catch(() => {});
      }
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
